<template>
    <div>
        <NavPage></NavPage>
        <div class="content">
          <SlideShow></SlideShow>
        </div>

        <div>
      <button>郑重声明：产品价格均以本公司正式书面公告或签署合约为准，对非官方报价不予承认！</button>
    </div>
    <div class="collapse">
      <el-collapse v-model="activeNames" class="custom" accordion>
        <el-collapse-item
          v-for="(productItem,index) in products"
          :key="index + 'collapse'"
          :name="index"
          style="margin-top:20px"
        >
          <template slot="title">
            <div class="custom-title">{{productItem.name}}</div>
          </template>
          <div>
            <el-table :data="productItem.productArr" style="width: 100%">
              <el-table-column prop="productArrId" label="序号" width="200" align="center"></el-table-column>
              <el-table-column prop="productArrName" label="产品名称" width="360" align="center"></el-table-column>
              <!-- <el-table-column prop="sensorModel" label="型号" width="260" align="center"></el-table-column> -->

              <el-table-column label="图片" align="center">
                <template #default="{ row }">
                  <img :src="row.src" alt="图片" v-if="row.src" style="width: 80px; height: 80px;" />
                  <span v-else>暂无图片</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
        
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import NavPage from "@/components/NavPage.vue";
import SlideShow from "@/components/SlideShow.vue";
import FooterPage from "@/components/FooterPage.vue";
import { products } from '@/view/products.js'

export default {
    name: "ProductPage",
    components: {
        NavPage,
        FooterPage,
        SlideShow,
        
    },
    data() {
        return {
            activeNames: ["1"],
            products
        }
    }
}
</script>

<style scoped>
.content {
 width: 1340px;
  margin: auto;
}
.slide img {
  width: 100%;
  height: 500px;
}
button {
  width: 70%;
  height: 60px;
  background-color: rgb(228, 133, 24);
  border: 0px;
  color: white;
  font-size: 22px;
  font-weight: 800;
  margin-top: 50px;
}
.collapse {
  width: 70%;
  /* height: 50px; */
  margin: auto;
}
.custom-title {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  background-color: #c6dfea;
  font-size: 20px;
  line-height: 50px;
}

::v-deep .el-collapse-item__content{
  margin-top: 20px;
}

::v-deep .el-collapse-item__arrow {
  display: none;
}
</style>